import React from 'react'
import { CustomInput } from 'src/consumer/components/helperComponents'
import { getChangedNumberValueFromInput, getNumberStringForInput } from 'src/mentor/helpers/utilityFunctions'

export default function PrintSidebarSettings({
  headingText = 'Sidebar Settings',
  sidebarSettings,
  setSidebarSettings,
}) {
  return (
    <>
      <div className="pt-3">
        <strong>{headingText}</strong>
        <div className="pt-1">
          <div className="d-flex flex-column gap-1">
            <CustomInput
              id="sidebarSettings"
              value={getNumberStringForInput(sidebarSettings?.width)}
              type="number"
              label="Sidebar Width in Inches"
              onChange={(e) => {
                setSidebarSettings((prev) => ({
                  ...prev,
                  width: getChangedNumberValueFromInput(e.target.value),
                }))
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}
